import { CanvasTexture, Group, Sprite, SpriteMaterial } from 'three';

export const ISLAND_SELECTION_GROUP_TYPE = 'island-selection-labels';
export const APPLIANCE_SELECTION_GROUP_TYPE = 'appliance-selection-labels';
export const SELECTION_GROUP_TYPES = [ISLAND_SELECTION_GROUP_TYPE, APPLIANCE_SELECTION_GROUP_TYPE] as const;

const CANVAS_SIZE = 128;
const LABEL_SIZE = 8;

/**
 * Convert a 1-based index to an uppercase letter (1=A, 2=B, ..., 26=Z, 27=AA, etc.)
 */
export const indexToLetter = (index: number): string => {
	let result = '';
	let remaining = index;
	while (remaining > 0) {
		remaining--;
		result = String.fromCharCode(65 + (remaining % 26)) + result;
		remaining = Math.floor(remaining / 26);
	}
	return result;
};

/**
 * Create a labeled circle sprite texture on an offscreen canvas
 */
export const createLabelSprite = (label: string): Sprite => {
	const canvas = document.createElement('canvas');
	canvas.width = CANVAS_SIZE;
	canvas.height = CANVAS_SIZE;
	const ctx = canvas.getContext('2d')!;

	// Draw white circle with dark border
	const center = CANVAS_SIZE / 2;
	const radius = (CANVAS_SIZE / 2) - 4;
	ctx.beginPath();
	ctx.arc(center, center, radius, 0, Math.PI * 2);
	ctx.fillStyle = 'rgba(255, 255, 255, 0.95)';
	ctx.fill();
	ctx.lineWidth = 4;
	ctx.strokeStyle = '#333333';
	ctx.stroke();

	// Draw label
	ctx.fillStyle = '#333333';
	ctx.font = `bold ${label.length > 1 ? 48 : 64}px Arial`;
	ctx.textAlign = 'center';
	ctx.textBaseline = 'middle';
	ctx.fillText(label, center, center);

	const texture = new CanvasTexture(canvas);
	const material = new SpriteMaterial({
		map: texture,
		depthTest: false,
		depthWrite: false
	});
	const sprite = new Sprite(material);
	sprite.scale.set(LABEL_SIZE, LABEL_SIZE, 1);
	sprite.renderOrder = 999;

	return sprite;
};

/**
 * Dispose all sprite materials and textures in a group, then remove from parent
 */
export const disposeSelectionGroup = (group: Group): void => {
	group.traverse((obj) => {
		if (obj instanceof Sprite) {
			obj.material.map?.dispose();
			obj.material.dispose();
		}
	});
	group.parent?.remove(group);
};

/**
 * Remove selection label groups of the given types from the object holder
 */
export const removeSelectionGroups = (
	objectHolder: Group,
	types: ReadonlyArray<string>
): void => {
	const toRemove = objectHolder.children.filter(
		(child) => types.includes(child.userData?.type)
	);
	toRemove.forEach((group) => disposeSelectionGroup(group as Group));
};
